import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Stack,
  Button,
  IconButton,
  MenuItem,
  TextField,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const AccessoryDisabledCombinationsForm = ({
  customizationOptions = [],
  disabledCombinations = [],
  onChange,
}) => {
  const [combinations, setCombinations] = useState(disabledCombinations);

  useEffect(() => {
    setCombinations(disabledCombinations);
  }, [disabledCombinations]);

  const handleFieldChange = (index, key, value) => {
    const updated = [...combinations];
    updated[index] = {
      combination: {
        ...updated[index].combination,
        [key]: value,
      },
    };
    setCombinations(updated);
    onChange(updated);
  };

  const handleAddCombination = () => {
    setCombinations((prev) => [...prev, { combination: {} }]);
  };

  const handleRemove = (index) => {
    const updated = [...combinations];
    updated.splice(index, 1);
    setCombinations(updated);
    onChange(updated);
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
        Mark Sub-Options as Out of Stock
      </Typography>

      <Stack spacing={2}>
        {combinations.map((entry, index) => (
          <Paper
            key={index}
            sx={{ p: 2, display: "flex", gap: 2, alignItems: "center" }}>
            {customizationOptions.map((field) => (
              <TextField
                key={field.label}
                select
                label={field.label}
                value={entry.combination[field.label] || ""}
                onChange={(e) =>
                  handleFieldChange(index, field.label, e.target.value)
                }
                sx={{ minWidth: 140 }}>
                {field.options.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
              </TextField>
            ))}

            <IconButton onClick={() => handleRemove(index)}>
              <DeleteIcon />
            </IconButton>
          </Paper>
        ))}

        <Button
          onClick={handleAddCombination}
          variant="outlined"
          sx={{ alignSelf: "start" }}>
          + Add Combination
        </Button>
      </Stack>
    </Box>
  );
};

export default AccessoryDisabledCombinationsForm;
